module.exports = __webpack_public_path__ + "static/media/BR 1.8aaec65d.mp3";